import { jsx as a } from "../../../../../external/preact/jsx-runtime/dist/jsxRuntime.module.js";
import _ from "../../../../../core/Context/useCoreContext.js";
import { useMemo as c, useCallback as v } from "../../../../../external/preact/hooks/dist/hooks.module.js";
import { getExpectedRepaymentDate as x, calculateMaximumRepaymentPeriodInMonths as I, getPaymentRatePercentage as M } from "../utils/utils.js";
import n from "../../../../internal/Typography/Typography.js";
import { TypographyElement as m, TypographyVariant as l } from "../../../../internal/Typography/types.js";
/* empty css                         */
import y from "../../../../internal/Button/Button.js";
import { ButtonVariant as C } from "../../../../internal/Button/types.js";
import k from "../../../../../hooks/useMutation/useMutation.js";
import { Tooltip as D } from "../../../../internal/Tooltip/Tooltip.js";
import { AlertTypeOption as E } from "../../../../internal/Alert/types.js";
import { Alert as b } from "../../../../internal/Alert/Alert.js";
import { CapitalErrorMessageDisplay as F } from "../utils/CapitalErrorMessageDisplay.js";
import L from "classnames";
import { CAPITAL_REPAYMENT_FREQUENCY as P } from "../../../../constants.js";
import { CapitalOfferLegalNotice as S } from "../CapitalOfferLegalNotice/CapitalOfferLegalNotice.js";
import W from "../../../../internal/InfoBox/InfoBox.js";
import q from "../../../../internal/StructuredList/StructuredList.js";
import { Icon as Y } from "../../../../internal/Icon/Icon.js";
import { useConfigContext as w } from "../../../../../core/ConfigContext/context.js";
import { EMPTY_OBJECT as H } from "../../../../../utils/value/constants.js";
const B = ["30_013"], ce = ({
  grantOffer: t,
  onBack: h,
  onFundsRequest: u,
  onContactSupport: p
}) => {
  const { i18n: e } = _(), f = c(() => {
    const r = x(t.expectedRepaymentPeriodDays);
    return r ? e.date(r, { month: "long" }) : null;
  }, [t, e]), { requestFunds: N } = w().endpoints, o = k({
    queryFn: N,
    options: {
      onSuccess: (r) => u == null ? void 0 : u(r)
    }
  }), A = v(
    (r) => {
      o.mutate(H, { path: { grantOfferId: r } });
    },
    [o]
  ), R = v(() => {
    t.id && A(t.id);
  }, [t.id, A]), s = c(
    () => I(t.maximumRepaymentPeriodDays),
    [t.maximumRepaymentPeriodDays]
  ), i = c(() => {
    const r = o.error ? o.error : null;
    if (r && B.includes(r.errorCode))
      switch (r.errorCode) {
        case "30_013":
          return {
            title: e.get("capital.thereIsNoPrimaryAccountConfigured"),
            message: e.get("capital.weCouldNotContinueWithTheOfferContactSupportForHelp"),
            errorCode: "30_013"
          };
        default:
          return {
            title: e.get("somethingWentWrong"),
            message: e.get("capital.weCouldNotLoadFinancialOffers")
          };
      }
    return null;
  }, [e, o.error]), T = c(() => {
    const r = [
      {
        key: "capital.fees",
        value: e.amount(t.feesAmount.value, t.feesAmount.currency)
      },
      {
        key: "capital.totalRepaymentAmount",
        value: e.amount(t.totalAmount.value, t.totalAmount.currency)
      },
      {
        key: "capital.repaymentThreshold",
        value: e.amount(t.thresholdAmount.value, t.thresholdAmount.currency)
      },
      {
        key: "capital.dailyRepaymentRate",
        value: e.get("capital.xPercent", { values: { percentage: M(t.repaymentRate) } })
      },
      {
        key: "capital.expectedRepaymentPeriod",
        value: e.get("capital.xDays", { values: { days: t.expectedRepaymentPeriodDays } })
      },
      { key: "account", value: e.get("capital.primaryAccount") }
    ];
    return s && r.splice(4, 0, {
      key: "capital.maximumRepaymentPeriod",
      value: s === 1 ? e.get("capital.oneMonth") : e.get("capital.xMonths", { values: { months: s } })
    }), r;
  }, [t, e, s]);
  return !i && o.error ? /* @__PURE__ */ a(F, { error: o.error, onBack: h, onContactSupport: p }) : /* @__PURE__ */ a("div", { className: "adyen-pe-capital-offer-summary", children: [
    /* @__PURE__ */ a(W, { className: "adyen-pe-capital-offer-summary__grant-summary", children: [
      /* @__PURE__ */ a(n, { el: m.PARAGRAPH, variant: l.BODY, children: [
        e.get("capital.youAreRequestingFundingOf"),
        " ",
        /* @__PURE__ */ a("strong", { children: `${e.amount(t.grantAmount.value, t.grantAmount.currency, { minimumFractionDigits: 0 })}.` })
      ] }),
      /* @__PURE__ */ a(n, { el: m.PARAGRAPH, variant: l.CAPTION, children: e.get("capital.youWillNeedToRepayAMinimumOfXEveryXDaysToPayOffTheFunds", {
        values: {
          amount: e.amount(t.thresholdAmount.value, t.thresholdAmount.currency),
          days: P,
          date: f ?? ""
        }
      }) })
    ] }),
    /* @__PURE__ */ a(
      q,
      {
        classNames: "adyen-pe-capital-offer-summary__details",
        renderLabel: (r, d) => d === "capital.repaymentThreshold" ? /* @__PURE__ */ a(
          D,
          {
            isContainerHovered: !0,
            content: e.get("capital.minimumRepaymentToRepayTheFinancingOnTime", {
              values: { days: P }
            }),
            children: /* @__PURE__ */ a("span", { children: /* @__PURE__ */ a(
              n,
              {
                className: "adyen-pe-capital-offer-summary__list-label",
                el: m.SPAN,
                variant: l.CAPTION,
                children: r
              }
            ) })
          }
        ) : /* @__PURE__ */ a(
          n,
          {
            className: "adyen-pe-capital-offer-summary__list-label",
            el: m.SPAN,
            variant: l.CAPTION,
            children: r
          }
        ),
        renderValue: (r, d) => {
          const g = d === "account" && o.error && i && i.errorCode === "30_013";
          return /* @__PURE__ */ a(
            n,
            {
              className: L({
                "adyen-pe-capital-offer-summary__details--error": g
              }),
              el: m.SPAN,
              variant: l.CAPTION,
              stronger: !0,
              children: [
                g ? /* @__PURE__ */ a(Y, { name: "warning-filled" }) : null,
                r
              ]
            }
          );
        },
        items: T
      }
    ),
    i && /* @__PURE__ */ a(
      b,
      {
        className: "adyen-pe-capital-offer-summary__error-alert",
        type: E.WARNING,
        title: i.title,
        description: i.message,
        children: p ? /* @__PURE__ */ a(y, { className: "adyen-pe-capital-offer-summary__error-alert-button", onClick: p, children: e.get("contactSupport") }) : null
      }
    ),
    /* @__PURE__ */ a(S, {}),
    /* @__PURE__ */ a("div", { className: "adyen-pe-capital-offer-summary__buttons", children: [
      o.error && !i ? null : /* @__PURE__ */ a(y, { variant: C.SECONDARY, onClick: h, children: e.get("back") }),
      /* @__PURE__ */ a(
        y,
        {
          variant: C.PRIMARY,
          state: o.isLoading ? "loading" : void 0,
          onClick: R,
          disabled: o.isLoading || !!o.error,
          children: e.get(o.isLoading ? "capital.requesting" : "capital.requestFunds")
        }
      )
    ] })
  ] });
};
export {
  ce as CapitalOfferSummary
};
